import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { isRtlLang } from '../i18n/config';

/**
 * Keeps document lang/dir and font stack in sync with i18n (RTL for Arabic, LTR + Inter for others).
 */
const DocumentI18nSync: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const apply = (lng: string) => {
      const base = String(lng || 'ar').split('-')[0];
      const rtl = isRtlLang(base);
      document.documentElement.setAttribute('dir', rtl ? 'rtl' : 'ltr');
      document.documentElement.setAttribute('lang', base);
      document.documentElement.classList.toggle('lang-rtl', rtl);
      document.documentElement.classList.toggle('lang-ltr', !rtl);
    };

    apply(i18n.language || 'ar');
    const handler = (lng: string) => apply(lng);
    i18n.on('languageChanged', handler);
    return () => {
      i18n.off('languageChanged', handler);
    };
  }, [i18n]);

  return null;
};

export default DocumentI18nSync;
